import { format, isAfter, isBefore, isFuture, isSameHour, isSameMinute, isValid, parseISO, } from 'date-fns';
import { fromZonedTime, toZonedTime } from 'date-fns-tz';
import { TODAYS_OPEN_STATUS } from '../../enums/index.js';
const TIMEZONE = 'Europe/Amsterdam';
export const getStoreTimes = (storeTimes) => {
    const todayUTC = getTodayTimesUTC(storeTimes);
    const nextOpenDayUTC = getNextOpenDayUTC(storeTimes);
    const isNewStoreThatWillOpenSoon = storeTimes.storeDates.openingDate !== null && isFuture(storeTimes.storeDates.openingDate);
    const now = new Date();
    const willOpenLaterToday = todayUTC ? isBefore(now, todayUTC.openTime) : false;
    // isAfter doesn't handle the case where the current time is the exact same as the closing time
    // so checking if the hour and minute are the same as well
    const wasOpenEarlierToday = todayUTC
        ? isAfter(now, todayUTC.closeTime) ||
            (isSameHour(now, todayUTC.closeTime) && isSameMinute(now, todayUTC.closeTime))
        : false;
    return {
        isNewStoreThatWillOpenSoon,
        today: todayUTC
            ? {
                date: todayUTC.date,
                openTime: fromUtcToZonedTime(todayUTC.openTime),
                closeTime: fromUtcToZonedTime(todayUTC.closeTime),
            }
            : null,
        nextOpenDay: nextOpenDayUTC
            ? {
                date: nextOpenDayUTC.date,
                openTime: fromUtcToZonedTime(nextOpenDayUTC.openTime),
                closeTime: fromUtcToZonedTime(nextOpenDayUTC.closeTime),
            }
            : null,
        todaysOpenStatus: willOpenLaterToday
            ? TODAYS_OPEN_STATUS.OPENING_LATER
            : wasOpenEarlierToday
                ? TODAYS_OPEN_STATUS.WAS_OPEN
                : TODAYS_OPEN_STATUS.OPEN_NOW,
    };
};
const getTodayTimesUTC = (storeTimes) => {
    const today = getToday();
    const todaySchedule = storeTimes.schedules.find(schedule => schedule.scheduleDate === today);
    if (todaySchedule && !todaySchedule.isClosed) {
        const openTimeUTC = parseStoreTimeToUtc(todaySchedule.scheduleDate, todaySchedule.openTime);
        const closeTimeUTC = parseStoreTimeToUtc(todaySchedule.scheduleDate, todaySchedule.closeTime);
        return {
            date: today,
            openTime: openTimeUTC,
            closeTime: closeTimeUTC,
        };
    }
    else {
        return null;
    }
};
const getNextOpenDayUTC = (storeTimes) => {
    const today = getToday();
    const nextOpenSchedule = storeTimes.schedules
        .filter(schedule => {
        return schedule.scheduleDate > today && !schedule.isClosed;
    })
        .sort((a, b) => a.scheduleDate.localeCompare(b.scheduleDate))[0];
    if (!nextOpenSchedule) {
        return null;
    }
    const openTimeUTC = parseStoreTimeToUtc(nextOpenSchedule.scheduleDate, nextOpenSchedule.openTime);
    const closeTimeUTC = parseStoreTimeToUtc(nextOpenSchedule.scheduleDate, nextOpenSchedule.closeTime);
    return {
        date: nextOpenSchedule.scheduleDate,
        openTime: openTimeUTC,
        closeTime: closeTimeUTC,
    };
};
// Go from UTC to zoned time to roll over to the next day if it's just before midnight
const getToday = () => format(fromUtcToZonedTime(new Date()), 'yyyy-MM-dd');
const parseStoreTimeToUtc = (dateStr, timeStr) => {
    const combinedStr = `${dateStr}T${timeStr}`;
    const localDate = parseISO(combinedStr);
    if (!isValid(localDate)) {
        console.error(`Invalid date or time format: ${combinedStr}`);
        return new Date();
    }
    return fromZonedTime(localDate, TIMEZONE);
};
const fromUtcToZonedTime = (date) => {
    return toZonedTime(date, TIMEZONE);
};
//# sourceMappingURL=getStoreTimes.js.map